import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import ExportDialogComponent from './export-dialog.component';
import { IconsModule, MonEventTriggerModule } from '@monsido/angular-shared-components';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MonEventTriggerModule,
        IconsModule,
    ],
    exports: [ExportDialogComponent],
    declarations: [ExportDialogComponent],
})
export class ExportDialogModule {}
